var FilterTools;
(function (FilterTools) {
    const $toolsContainers = document.querySelectorAll('.paragraph.tools');
    function bindSelect() {
        const $countrySelect = document.querySelector('#footer .body .content-wrapper .country-switcher label select');
        let country = localStorage.country;
        let $countrySelected;
        if (country) {
            $countrySelected = country;
        }
        $countrySelect.value = $countrySelected;
        return $countrySelected;
    }
    function changeDetect() {
        const $countrySelect = document.querySelector('#footer .body .content-wrapper .country-switcher label select');
        const $country = $countrySelect.querySelector('option:checked');
        if (!localStorage.country) {
            localStorage.setItem('country', $country.value);
        }
        $countrySelect.addEventListener('change', () => {
            const $country = $countrySelect.querySelector('option:checked');
            localStorage.setItem('country', $country.value);
            window.location.reload();
        });
    }
    function filter() {
        if ($toolsContainers.length) {
            $toolsContainers.forEach($toolsContainer => {
                const $tools = $toolsContainer.querySelectorAll('.vocabulary-tool');
                let $countrySelected = bindSelect();
                if ($countrySelected != 'All') {
                    $tools.forEach($tool => {
                        const $countryID = $tool.querySelector('.country .id');
                        const $countryName = $tool.querySelector('.country a');
                        if ($countryName != null && $countryID.innerHTML != null) {
                            //debugger;
                            if ($countrySelected != $countryID.innerHTML.replace(/\s/g, "") && $countryName.innerHTML != 'All') {
                                $tool.remove();
                            }
                        }
                    });
                }
            });
        }
    }
    function init() {
        changeDetect();
        bindSelect();
        filter();
    }
    init();
})(FilterTools || (FilterTools = {}));
